import { isOwnSelectableUnit } from "#/game/selection/transitions";
import type { StoreState } from "#/game/store/types";

export function canEndTurnFromState(state: StoreState): boolean {
  return (
    !state.animation &&
    !state.isSubmitting &&
    !state.aiPlayback &&
    state.localState.currentPlayer === "p1" &&
    state.localState.status === "in_progress" &&
    state.selection.mode !== "confirm-attack" &&
    state.selection.mode !== "confirm-capture-reset"
  );
}

export function hasUnactedOwnUnitsFromState(state: StoreState): boolean {
  if (state.localState.currentPlayer !== "p1") return false;
  return state.localState.units.some((unit) => isOwnSelectableUnit(state.localState, unit));
}

export function unactedOwnUnitIdsFromState(state: StoreState): string[] {
  if (state.localState.currentPlayer !== "p1") return [];
  return state.localState.units
    .filter((unit) => isOwnSelectableUnit(state.localState, unit))
    .map((unit) => unit.id);
}

export function canUndoFromState(state: StoreState): boolean {
  return (
    !state.animation &&
    !state.isSubmitting &&
    !state.aiPlayback &&
    state.localState.currentPlayer === "p1" &&
    state.localState.status === "in_progress" &&
    state.pendingMoves.length > 0
  );
}
